<script setup lang="ts">
import NullData from "@/assets/svg/null_data.svg?component"

defineProps({
  msg: {
    type: String,
    default: "暂无数据"
  }
})
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <slot name="img">
      <NullData class="max-w-[500px] m-auto" />
    </slot>
    <span class="translate-y-[-50px]">{{ msg }}</span>
  </div>
</template>
